import Iconify from "@/components/ui/Iconify";
import { useTranslations } from "@/lib/static-intl";
import { useEffect, useRef, useState } from "react";

const PDW_PlaceTabInformationSection = ({ isCssForDialog, place }) => {
  const t = useTranslations("places.place_details_window");
  const introTextRef = useRef(null);
  const [isIntroExpanded, setIsIntroExpanded] = useState(false);
  const [introLineCount, setIntroLineCount] = useState(0);

  useEffect(() => {
    if (introTextRef.current) {
      const element = introTextRef.current;
      const lineHeight = parseFloat(
        window.getComputedStyle(element).lineHeight
      );
      const height = element.clientHeight;
      setIntroLineCount(Math.round(height / lineHeight));
    }
  }, []);

  return (
    <div className="w-full min-h-[80vh] flex flex-col pb-10">
      <div
        className={`w-full ${
          isCssForDialog ? "p-3" : "p-5"
        } bg-transparent flex flex-col gap-2 rounded-2xl`}
      >
        <span className="text-lg font-semibold dark:text-white">
          {t("introduction")}
        </span>
        <div
          className={`w-full flex flex-col gap-2 bg-white dark:bg-brown border border-black/[0.08] dark:border-white/[0.12] rounded-2xl p-4`}
        >
          <pre
            ref={introTextRef}
            className={`w-full font-sans text-wrap break-words relative ${
              introLineCount < 10
                ? "h-fit"
                : isIntroExpanded
                ? "h-fit"
                : "h-[250px] overflow-hidden"
            }`}
          >
            {introLineCount >= 10 && !isIntroExpanded && (
              <div className="w-full h-12 bg-gradient-to-b from-transparent from-0% to-white dark:to-brown to-100% absolute bottom-0 left-0 right-0 z-20" />
            )}
            {place?.introduction || t("intro_text")}
          </pre>
          {introLineCount >= 10 && (
            <div className="w-full flex items-center justify-center">
              <button
                type="button"
                className="w-fit"
                onClick={() => setIsIntroExpanded((prev) => !prev)}
              >
                <Iconify
                  icon={"ep:arrow-down"}
                  className={`${
                    isIntroExpanded ? "rotate-180" : "rotate-0"
                  } transition !min-w-5 !w-5 !h-5 opacity-60 !text-black/90 dark:!text-white/90`}
                />
              </button>
            </div>
          )}
        </div>
      </div>
      {place?.amenities && (
        <div className="w-full flex flex-col gap-2 px-2 border-b dark:border-brown py-5 dark:text-white">
          <span className="text-lg font-semibold">{t("amenities")}</span>
          <div className="w-full flex items-start gap-5">
            <Iconify icon={"mdi:help-outline"} className={"!min-w-7 !h-7"} />
            <pre className="font-sans text-wrap break-words">
              {place?.amenities}
            </pre>
          </div>
        </div>
      )}
      {place?.parking && (
        <div className="w-full flex flex-col gap-2 px-2 border-b dark:border-brown py-5 dark:text-white">
          <span className="text-lg font-semibold">{t("parking")}</span>
          <div className="w-full flex items-start gap-5">
            <Iconify icon={"guidance:parking"} className={"!min-w-7 !h-7"} />
            <pre className="font-sans text-wrap break-words">
              {place?.parking}
            </pre>
          </div>
        </div>
      )}
      {place?.seating && (
        <div className="w-full flex flex-col gap-2 px-2 py-5 dark:text-white">
          <span className="text-lg font-semibold">{t("seating")}</span>
          <div className="w-full flex items-start gap-5">
            <Iconify icon={"fa6-solid:chair"} className={"!min-w-7 !h-7"} />
            <p className="font-sans text-wrap break-words">{place?.seating}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PDW_PlaceTabInformationSection;
